/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowhellosubtitle3Inputs */

const en_aiflowhellosubtitle3 = /** @type {(inputs: Aiflowhellosubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One sentence, a link or a picture of the flyer is enough. We ask about the rest, or you just let us do it.`)
};

const de_aiflowhellosubtitle3 = /** @type {(inputs: Aiflowhellosubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Satz, ein Link oder ein Bild vom Flyer reicht. Den Rest fragen wir kurz nach, oder du lässt uns einfach machen.`)
};

/**
* | output |
* | --- |
* | "One sentence, a link or a picture of the flyer is enough. We ask about the rest, or you just let us do it." |
*
* @param {Aiflowhellosubtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowhellosubtitle3 = /** @type {((inputs?: Aiflowhellosubtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowhellosubtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowhellosubtitle3(inputs)
	return de_aiflowhellosubtitle3(inputs)
});
export { aiflowhellosubtitle3 as "aiFlowHelloSubtitle" }